import { useOutletContext } from "react-router-dom";
import { useAuth0 } from "@auth0/auth0-react";

import { useMiningData } from "api/mining";
import { useElectricityData } from "api/electricity";
import { useGasData } from "api/gas";

import BtcEarnings from "components/BtcEarnings";
import BitcoinProduction from "components/Graph/BitcoinProduction";
import EarningsVsCost from "components/EarningsVsCost";
import ExchangeRateOutput from "components/ExchangeRateOutput";

export default function BitcoinEarnings() {
  const { user } = useAuth0();

  const [farmName, dayRange] = useOutletContext<any>();

  const { data: miningData } = useMiningData(user["https://hasura.io/jwt/claims"]["x-hasura-user-id"], dayRange, farmName);
  const { data: electricityData } = useElectricityData(user["https://hasura.io/jwt/claims"]["x-hasura-user-id"], dayRange, farmName);
  const { data: gasData } = useGasData(user["https://hasura.io/jwt/claims"]["x-hasura-user-id"], dayRange, farmName);

  return !miningData || !electricityData ? null : (
    <>
      <div className="mt-5 px-5 lg:px-12 max-w-sm md:max-w-7xl mx-auto grid gap-5 md:grid-cols-2 lg:grid-cols-3 items-start">
        <div className="col-span-2 output-card p-7">
          <div className="flex-shrink-0 mb-3 text-gray-500 font-bold">Bitcoin Earnings / Hashrate</div>
          <div className="flex flex-col justify-between">
            <BtcEarnings className="py-2" data={miningData.data} />
            <div className="mt-7 pt-5 border-t border-gray-200 border-dotted -ml-7 -mr-7"></div>
            <BitcoinProduction
              className="max-h-40 w-full"
              title="Bitcoin Production Vs Energy Consumption"
              firstData={{ title: "Bitcoin Production", ...miningData }}
              secondData={{ title: "Energy Consumed", ...electricityData }}
            />
          </div>
        </div>
        <EarningsVsCost miningData={miningData} electricityData={electricityData} gasData={gasData} />
      </div>
      <ExchangeRateOutput title="BTC" unit="BTC" rate={miningData.total.exchangeRate} timestamp={miningData.total.timestamp} />
    </>
  );
}
